// @ts-strict

import { AfterViewInit, Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { isEmpty } from 'lodash';
import { Subject } from 'rxjs';
import { delay, takeUntil, tap } from 'rxjs/operators';

@Component({
  selector: 'app-mode-switch',
  templateUrl: './mode-switch.component.html',
  styleUrls: ['./mode-switch.component.scss']
})
export class ModeSwitchComponent implements OnInit, AfterViewInit, OnDestroy {
  @Output() currentSwitchState = new EventEmitter<string>();
  @Input() section = '';
  @Input() switchButtons: {
    id: string;
    name: string;
  }[] = [];

  public activeMode?: {
    id: string;
    name: string;
  };
  private destroy$ = new Subject<boolean>();

  constructor(private translate: TranslateService) {}

  @HostListener('window:resize')
  resize(): void {
    this.onResize();
  }

  ngOnInit(): void {
    this.activeMode = this.switchButtons[0];
    if (this.section === 'countries') {
      this.activeMode = this.switchButtons[1];
    }
    this.currentSwitchState.emit(this.activeMode.id);

    this.translate.onLangChange
      .pipe(
        delay(500),
        tap(() => {
          if (!isEmpty(this.activeMode)) {
            const movingElement = document.getElementById('moving-part-mode')!;
            const selected = document.getElementById(this.activeMode.id)!;

            movingElement.style.width = `${selected.offsetWidth}px`;
            movingElement.style.left = `${selected.offsetLeft}px`;
          }
        }),
        takeUntil(this.destroy$)
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  ngAfterViewInit(): void {
    this.setMinWidth();

    if (!isEmpty(this.activeMode)) {
      this.switchMode(this.activeMode);
    }
  }

  public onResize(): void {
    if (!isEmpty(this.activeMode)) {
      this.switchMode(this.activeMode);
    }
  }

  public switchMode(mode: { id: string; name: string }): void {
    const movingElement = document.getElementById('moving-part-mode')!;
    const element1 = document.getElementById(`${this.switchButtons[0].id}`)!;
    const element2 = document.getElementById(`${this.switchButtons[1].id}`)!;
    const element1Offset = element1.offsetLeft;
    const element2Offset = element2.offsetLeft;

    if (mode !== this.activeMode) {
      if (this.activeMode === this.switchButtons[0]) {
        this.activeMode = this.switchButtons[1];
        movingElement.style.left = `${element2Offset}px`;
      } else {
        this.activeMode = this.switchButtons[0];
        movingElement.style.left = `${element1Offset}px`;
      }
      this.currentSwitchState.emit(this.activeMode.id);
    }
    this.adjustMovingElementSize();
  }

  private adjustMovingElementSize(): void {
    const movingElement = document.getElementById('moving-part-mode')!;
    const element1 = document.getElementById(`${this.switchButtons[0].id}`)!;
    const element2 = document.getElementById(`${this.switchButtons[1].id}`)!;

    if (!isEmpty(this.activeMode) && this.activeMode.id === this.switchButtons[0].id) {
      movingElement.style.width = `${element1.offsetWidth}px`;
    } else {
      movingElement.style.width = `${element2.offsetWidth}px`;
      movingElement.style.right = `5px`;
      movingElement.style.left = 'unset';
    }
  }

  private setMinWidth(): void {
    const privateAccountElement = document.getElementById(`${this.switchButtons[0].id}`)!;
    const companyAccountElement = document.getElementById(`${this.switchButtons[1].id}`)!;

    privateAccountElement.style.minWidth = `10px`;
    companyAccountElement.style.minWidth = `10px`;
  }
}
